import { toast } from "react-toastify";
import { useMutation } from "@tanstack/react-query";

import { MutationError } from "@Types/index";
import { createLenderNote } from "@Http/notes";
import { CreateNoteRequest, LenderNote } from "@Types/notes";

export const useCreateNote = () => {
  const mutation = useMutation<LenderNote, MutationError, CreateNoteRequest>(
    createLenderNote(),
    {
      onSuccess: () => {
        toast.success("Successfully created a note.", {
          position: "top-center",
        });
      },
    }
  );
  return {
    createNote: mutation.mutate,
    loading: mutation.isLoading,
    success: mutation.isSuccess,
    error: mutation.error,
  };
};
